import { Pipeable } from './pipeable.js';
import { ArrayCompositionPipeableMixin } from './array_composition_pipeable_mixin.js';

const ArrayCompositionPipeable = ArrayCompositionPipeableMixin(Pipeable);

export { ArrayCompositionPipeable };
